import Action from '../../Action'
import { useState, useEffect } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';

const ModalHostList = ({
  source, infoMarker, filteredEvents, server, languaje,
  handleShowPopup, mode, hosts, elementsList, SetElementList,
  setDataWorkFlow, dataWorkFlow, brand, closHostsListModal
}) => {
  const [poolRows, setPoolRows] = useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [response, setResponse] = useState([])
  const startLimit = limitList * pageActual - limitList;
  const [loadingM, setLoadingM] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)
  const [hostsList, setHostList] = useState(JSON.parse(infoMarker.hosts))
  const [statusSelected, setStatusSelected] = useState('')

  var dataList = searchTerm === "" ? hostsList : searchResults;
  const pages = parseInt(dataList.length / limitList) + 1;

  const handleSelectAll = () => {
    if (allSelected) { setPoolRows([]); }
    else { setPoolRows(hosts.map(item => item.hostid)) }
    setAllSelected(!allSelected);
  };
  const handleSearch = (query) => { setSearchResult(`Resultados para: ${query}`); };
  const handleSelectChange = (e) => { setPageActual(1); setLimitList(e.target.value); };

  function updateStats(devices) {
    const stats = {
      totalHosts: devices.length, ok: 0, down: 0, unknown: 0,
      maintenance: 0, exceptions: 0,
      ok_maintenance: 0, ok_exceptions: 0,
      down_maintenance: 0, down_exceptions: 0,
      unknown_maintenance: 0, unknown_exceptions: 0,
      total_maintenance: 0, total_exceptions: 0
    };
    devices.forEach(item => {
      const status = item.status;
      const isMaint = item.in_maintenance;
      const isExcept = item.is_exception;
      if (status === "ok") stats.ok++;
      if (status === "offline") stats.down++;
      if (status === "unknown") stats.unknown++;
      if (isMaint) stats.maintenance++;
      if (isExcept) stats.exceptions++;
      if (status === "ok" && isMaint) stats.ok_maintenance++;
      if (status === "ok" && isExcept) stats.ok_exceptions++;
      if (status === "down" && isMaint) stats.down_maintenance++;
      if (status === "down" && isExcept) stats.down_exceptions++;
      if (status === "unknown" && isMaint) stats.unknown_maintenance++;
      if (status === "unknown" && isExcept) stats.unknown_exceptions++;
      if (isMaint) stats.total_maintenance++;
      if (isExcept) stats.total_exceptions++;
    });
    return stats;
  }

  const stats = updateStats(JSON.parse(infoMarker.hosts));

  useEffect(() => {
    const filteredHosts = (statusSelected == '') ? JSON.parse(infoMarker.hosts) :
      ((statusSelected == 'mtto') ? JSON.parse(infoMarker.hosts).filter(item => item.in_maintenance === true) :
        ((statusSelected == 'except') ? JSON.parse(infoMarker.hosts).filter(item => item.is_exception === true) :
          JSON.parse(infoMarker.hosts).filter(item => item.status === statusSelected)));
    setHostList(filteredHosts)
  }, [statusSelected])

  // ── ÍCONOS ──
  const WarningIcon = () => (
    <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
      <path d="M7 1.5L12.5 11.5H1.5L7 1.5Z" stroke="#7e3af2" strokeWidth="1.3" fill="rgba(126,58,242,.08)" />
      <line x1="7" y1="5.5" x2="7" y2="8.5" stroke="#7e3af2" strokeWidth="1.2" strokeLinecap="round" />
      <circle cx="7" cy="10" r=".65" fill="#7e3af2" />
    </svg>
  );

  const ToolsIcon = () => (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
      <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
        fill="#fbbf24" stroke="#d97706" strokeWidth=".8" strokeLinejoin="round" />
      <path d="M11.5 2l1 1-1.5 1.5-1-1z" fill="#d97706" />
      <circle cx="5.5" cy="11.5" r="1" fill="#d97706" />
    </svg>
  );

  // ── HELPERS de color ──
  const getDotStyle = (status) => {
    if (status === 'ok') return { background: '#057a55', boxShadow: '0 0 0 2px rgba(5,122,85,.15)' };
    if (status === 'offline') return { background: '#db2777', boxShadow: '0 0 0 2px rgba(219,39,119,.15)' };
    return { background: '#94a3b8' };
  };

  const pct = (n) => ((n * 100) / stats.totalHosts).toFixed(2);

  // ── ESTILOS inline del sistema ──
  const S = {
    // Overlay
    overlay: {
      position: 'fixed', inset: 0,
      background: 'rgba(15,30,56,0.55)',
      backdropFilter: 'blur(3px)',
      WebkitBackdropFilter: 'blur(3px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    },
    // Modal container
    modal: {
      background: '#fff', borderRadius: 12,
      width: '100%',
      height: '100%',
      boxShadow: '0 24px 64px rgba(0,0,0,.35), 0 0 0 1px rgba(255,255,255,.06)',
      overflow: 'hidden', display: 'flex', flexDirection: 'column',
      animation: 'mhlSlideUp .2s ease'
    },
    // Header
    header: {
      background: '#0f2d5e', padding: '13px 18px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      flexShrink: 0
    },
    headerIcon: {
      width: 30, height: 30, borderRadius: 7,
      background: 'rgba(255,255,255,.12)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
    },
    headerTitle: { fontSize: 13, fontWeight: 500, color: '#fff' },
    headerSub: { fontSize: 11, color: 'rgba(255,255,255,.55)', marginTop: 1, fontFamily: 'monospace' },
    closeBtn: {
      width: 26, height: 26, borderRadius: 6,
      border: '0.5px solid rgba(255,255,255,.15)',
      background: 'rgba(255,255,255,.08)',
      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'rgba(255,255,255,.6)', outline: 'none'
    },
    // Counters row
    countersRow: {
      background: '#f1f5f9', borderBottom: '1px solid #e2e8f0',
      padding: '7px 14px', display: 'flex', alignItems: 'stretch',
      gap: 0, flexShrink: 0, overflowX: 'auto'
    },
    // Toolbar
    toolbar: {
      background: '#fff', borderBottom: '1px solid #e2e8f0',
      padding: '8px 16px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', gap: 10, flexShrink: 0, flexWrap: 'wrap'
    },
    // List wrapper
    listWrap: { flex: 1, overflowY: 'auto' },
    // Device item
    devItem: {
      borderBottom: '1px solid #e2e8f0',
      padding: '10px 16px', cursor: 'pointer', transition: 'background .12s'
    },
    // Footer
    footer: {
      padding: '8px 16px', borderTop: '1px solid #e2e8f0',
      background: '#f1f5f9', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexShrink: 0, flexWrap: 'wrap', gap: 8,
      height: '10%'
    },
  };

  // ── COMPONENTE CARD CONTADOR ──
  const CounterCard = ({ color, bg, label, count, pctVal, excVal, mttoVal, isActive, onClick, borderRight = true, dotColor }) => (
    <div
      onClick={onClick}
      style={{
        display: 'flex', flexDirection: 'column', gap: 2,
        padding: '5px 12px',
        borderRight: borderRight ? '1px solid #e2e8f0' : 'none',
        flexShrink: 0, cursor: 'pointer',
        background: isActive ? 'rgba(0,0,0,.04)' : 'transparent',
        transition: 'background .12s'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 2 }}>
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: dotColor || color, flexShrink: 0 }} />
        <span style={{ fontSize: 10, fontWeight: 600, color }}>{label}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
        <span style={{ fontSize: 20, fontWeight: 700, fontFamily: 'monospace', lineHeight: 1, color }}>{count}</span>
        <span style={{ fontSize: 9, fontWeight: 600, padding: '1px 5px', borderRadius: 4, background: bg, color }}>{pctVal}%</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 9, color: '#64748b' }}>
          <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
            <path d="M7 1.5L12.5 11.5H1.5L7 1.5Z" stroke="#94a3b8" strokeWidth="1.1" fill="none" />
            <line x1="7" y1="5.5" x2="7" y2="8" stroke="#94a3b8" strokeWidth="1" strokeLinecap="round" />
          </svg>
          {excVal} exc
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 9, color: '#64748b' }}>
          <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
            <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
              fill="rgba(148,163,184,.3)" stroke="#94a3b8" strokeWidth=".7" strokeLinejoin="round" />
          </svg>
          {mttoVal} mtto
        </span>
      </div>
    </div>
  );

  return (
    <>
      {/* Keyframe injection */}
      <style>{`
        @keyframes mhlSlideUp {
          from { opacity: 0; transform: translateY(14px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .mhl-devitem:hover { background: #f0f5ff !important; }
        .mhl-counter:hover { background: rgba(0,0,0,.03) !important; }
        .mhl-closebtn:hover { background: rgba(255,255,255,.18) !important; color: #fff !important; }
        .mhl-pagbtn { width:26px;height:26px;border-radius:5px;border:1px solid #e2e8f0;background:#fff;font-size:11px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#64748b; }
        .mhl-pagbtn.active { background:#1a56db;color:#fff;border-color:#1a56db; }
        .mhl-listscroll::-webkit-scrollbar { width: 4px; }
        .mhl-listscroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
      `}</style>

      <div style={S.overlay}>
        <div style={S.modal}>

          {/* ── HEADER ── */}
          <div style={S.header}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={S.headerIcon}>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                  <rect x="1" y="1" width="6" height="6" rx="1.5" stroke="#fff" strokeWidth="1.2" />
                  <rect x="9" y="1" width="6" height="6" rx="1.5" stroke="#fff" strokeWidth="1.2" />
                  <rect x="1" y="9" width="6" height="6" rx="1.5" stroke="#fff" strokeWidth="1.2" />
                  <rect x="9" y="9" width="6" height="6" rx="1.5" stroke="#fff" strokeWidth="1.2" />
                </svg>
              </div>
              <div>
                <div style={S.headerTitle}>Lista de dispositivos</div>
                <div style={S.headerSub}>{infoMarker.name}</div>
              </div>
            </div>
            <button style={S.closeBtn} className="mhl-closebtn" onClick={closHostsListModal}>
              <svg width="10" height="10" viewBox="0 0 10 10">
                <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          {/* ── CONTADORES — Opción C ── */}
          <div style={S.countersRow}>

            {/* Total */}
            <div style={{
              display: 'flex', flexDirection: 'column', gap: 2,
              padding: '5px 14px 5px 0',
              borderRight: '1px solid #e2e8f0', flexShrink: 0,
              cursor: 'pointer'
            }} onClick={() => setStatusSelected('')}>
              <div style={{ fontSize: 10, fontWeight: 500, color: '#334155' }}>Total Dispositivos</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', lineHeight: 1.2, fontFamily: 'monospace' }}>
                {stats.totalHosts}
              </div>
              <div style={{ fontSize: 9, color: '#64748b' }}>afiliaciones: 1</div>
            </div>

            {/* Conectados */}
            <CounterCard
              color="#057a55" bg="#d1fae5" label="Conectados"
              count={stats.ok} pctVal={pct(stats.ok)}
              excVal={stats.ok_exceptions} mttoVal={stats.ok_maintenance}
              isActive={statusSelected === 'ok'}
              onClick={() => setStatusSelected(statusSelected === 'ok' ? '' : 'ok')}
            />

            {/* Desconectados */}
            <CounterCard
              color="#db2777" bg="#fce7f3" label="Desconectados"
              count={stats.down} pctVal={pct(stats.down)}
              excVal={stats.down_exceptions} mttoVal={stats.down_maintenance}
              isActive={statusSelected === 'offline'}
              onClick={() => setStatusSelected(statusSelected === 'offline' ? '' : 'offline')}
            />

            {/* Desconocidos */}
            <CounterCard
              color="#94a3b8" bg="#f1f5f9" label="Desconocidos"
              count={stats.unknown} pctVal={pct(stats.unknown)}
              excVal={stats.unknown_exceptions} mttoVal={stats.unknown_maintenance}
              isActive={statusSelected === 'unknown'}
              onClick={() => setStatusSelected(statusSelected === 'unknown' ? '' : 'unknown')}
            />

            {/* EXCEP */}
            <div
              className="mhl-counter"
              onClick={() => setStatusSelected(statusSelected === 'except' ? '' : 'except')}
              style={{
                display: 'flex', flexDirection: 'column', gap: 2,
                padding: '5px 12px', borderRight: '1px solid #e2e8f0',
                flexShrink: 0, cursor: 'pointer',
                background: statusSelected === 'except' ? 'rgba(0,0,0,.04)' : 'transparent',
                transition: 'background .12s'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 2 }}>
                <svg width="11" height="11" viewBox="0 0 14 14" fill="none">
                  <path d="M7 1.5L12.5 11.5H1.5L7 1.5Z" stroke="#7e3af2" strokeWidth="1.2" fill="rgba(126,58,242,.08)" />
                  <line x1="7" y1="5.5" x2="7" y2="8.5" stroke="#7e3af2" strokeWidth="1.1" strokeLinecap="round" />
                  <circle cx="7" cy="10" r=".65" fill="#7e3af2" />
                </svg>
                <span style={{ fontSize: 10, fontWeight: 600, color: '#7e3af2' }}>EXCEP</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                <span style={{ fontSize: 20, fontWeight: 700, fontFamily: 'monospace', lineHeight: 1, color: '#7e3af2' }}>{stats.total_exceptions}</span>
                <span style={{ fontSize: 9, fontWeight: 600, padding: '1px 5px', borderRadius: 4, background: '#ede9fe', color: '#7e3af2' }}>{pct(stats.total_exceptions)}%</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 9, color: '#d97706', marginTop: 2 }}>
                <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                  <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
                    fill="#fbbf24" stroke="#d97706" strokeWidth=".8" strokeLinejoin="round" />
                </svg>
                Gestión global
              </div>
            </div>

            {/* MTTO */}
            <div
              className="mhl-counter"
              onClick={() => setStatusSelected(statusSelected === 'mtto' ? '' : 'mtto')}
              style={{
                display: 'flex', flexDirection: 'column', gap: 2,
                padding: '5px 12px', borderRight: 'none',
                flexShrink: 0, cursor: 'pointer',
                background: statusSelected === 'mtto' ? 'rgba(0,0,0,.04)' : 'transparent',
                transition: 'background .12s'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 2 }}>
                <svg width="11" height="11" viewBox="0 0 16 16" fill="none">
                  <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
                    fill="#fbbf24" stroke="#d97706" strokeWidth=".8" strokeLinejoin="round" />
                  <path d="M11.5 2l1 1-1.5 1.5-1-1z" fill="#d97706" />
                  <circle cx="5.5" cy="11.5" r="1" fill="#d97706" />
                </svg>
                <span style={{ fontSize: 10, fontWeight: 600, color: '#d97706' }}>MTTO</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                <span style={{ fontSize: 20, fontWeight: 700, fontFamily: 'monospace', lineHeight: 1, color: '#d97706' }}>{stats.total_maintenance}</span>
                <span style={{ fontSize: 9, fontWeight: 600, padding: '1px 5px', borderRadius: 4, background: '#fef3c7', color: '#d97706' }}>{pct(stats.total_maintenance)}%</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 9, color: '#d97706', marginTop: 2 }}>
                <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                  <path d="M11 2.5a3.5 3.5 0 0 1 .6 6.5L7 14a2 2 0 0 1-2.8-2.8L9.8 6a3.5 3.5 0 0 1 1.2-3.5z"
                    fill="#fbbf24" stroke="#d97706" strokeWidth=".8" strokeLinejoin="round" />
                </svg>
                Gestión global
              </div>
            </div>

          </div>

          {/* ── TOOLBAR ── */}
          <div style={S.toolbar}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, color: '#334155', fontWeight: 500 }}>
                Resultados:{' '}
                <span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#1a56db' }}>
                  {dataList.length}
                </span>
              </span>
            </div>
            {/* <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#2e78c3ff', border: '1px solid #e2e8f0', borderRadius: 6, padding: '5px 10px', minWidth: 240 }}> */}
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
              <circle cx="6" cy="6" r="4.5" stroke="#94a3b8" strokeWidth="1.3" />
              <line x1="9.5" y1="9.5" x2="12.5" y2="12.5" stroke="#94a3b8" strokeWidth="1.3" strokeLinecap="round" />
            </svg>
            <Search
              searchResults={searchResults}
              setSearchResults={setSearchResults}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onSearch={handleSearch}
              dataObject={hostsList}
              searchResult={searchResult}
              setSearchResult={setSearchResult}
              languaje={languaje}
            />
          </div>
          {/* </div> */}

          {/* ── LISTA DE DISPOSITIVOS ── */}
          <div style={{ ...S.listWrap }} className="mhl-listscroll">
            {loadingM ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
                <LoadSimple />
              </div>
            ) : (
              <>
                {dataList
                  .slice(dataList.length < limitList ? 0 : startLimit, parseInt(pageActual) * parseInt(limitList))
                  .map((elemento, indice) => (
                    <div
                      key={indice}
                      className="mhl-devitem"
                      style={S.devItem}
                    >
                      {/* Fila 1 — nombre + IP */}
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                          {/* Dot estado */}
                          <span style={{
                            width: 9, height: 9, borderRadius: '50%', flexShrink: 0,
                            ...getDotStyle(elemento.status)
                          }} />
                          {/* Ícono excepción */}
                          {elemento.is_exception && (
                            <span title="Con excepción" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 15, height: 15, flexShrink: 0 }}>
                              <WarningIcon />
                            </span>
                          )}
                          {/* Ícono mantenimiento */}
                          {elemento.in_maintenance && (
                            <span title="En mantenimiento" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 15, height: 15, flexShrink: 0 }}>
                              <ToolsIcon />
                            </span>
                          )}
                          {/* Nombre */}
                          <span style={{ fontSize: 12, fontWeight: 500, color: '#0f172a' }}>
                            {elemento.name}
                          </span>
                        </div>
                        {/* IP */}
                        <span style={{ fontFamily: 'monospace', fontSize: 10, color: '#64748b' }}>
                          {elemento.ip}
                        </span>
                      </div>

                      {/* Fila 2 — tags */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                        {/* Zona */}
                        {elemento.zones?.[0] && (
                          <span style={{
                            background: '#e8f0fe', color: '#1a56db', border: '1px solid #c3dafe',
                            borderRadius: 4, padding: '2px 8px', fontSize: 9, fontWeight: 500
                          }}>
                            {elemento.zones[0].name}
                          </span>
                        )}
                        {/* Tecnología */}
                        {elemento.tech?.name && (
                          <span style={{
                            background: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0',
                            borderRadius: 4, padding: '2px 8px', fontSize: 8, fontWeight: 600,
                            textTransform: 'uppercase', letterSpacing: '.04em'
                          }}>
                            {elemento.tech.name}
                          </span>
                        )}
                        {/* Grupos */}
                        {elemento.groups?.map((group, idx) => (
                          <span key={idx} style={{
                            background: '#f1f5f9', color: '#64748b', border: '1px solid #e2e8f0',
                            borderRadius: 4, padding: '2px 8px', fontSize: 9
                          }}>
                            {group.name}
                          </span>
                        ))}
                        {/* Tag excepción */}
                        {elemento.is_exception && (
                          <span style={{
                            background: '#ede9fe', color: '#7e3af2', border: '1px solid #c4b5fd',
                            borderRadius: 4, padding: '2px 8px', fontSize: 9, fontWeight: 500
                          }}>
                            ▲ Excepción
                          </span>
                        )}
                        {/* Tag mantenimiento */}
                        {elemento.in_maintenance && (
                          <span style={{
                            background: '#fef3c7', color: '#d97706', border: '1px solid #fde68a',
                            borderRadius: 4, padding: '2px 8px', fontSize: 9, fontWeight: 500
                          }}>
                            🔧 Mantto.
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                {dataList.length === 0 && (
                  <div style={{ padding: '32px 16px', textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>
                    {capitalizeFirstLetter(lang[languaje]['sinResultados'])}.
                  </div>
                )}
              </>
            )}
          </div>

          {/* ── FOOTER ── */}
          <div style={S.footer}>
            {/* Filas por página */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 10, color: '#64748b' }}>
              <label htmlFor="mhl-selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}:</label>
              <select
                id="mhl-selector"
                value={limitList}
                onChange={handleSelectChange}
                style={{ fontSize: 10, padding: '3px 5px', border: '1px solid #e2e8f0', borderRadius: 4, color: '#334155', background: '#fff', outline: 'none' }}
              >
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
              </select>
            </div>

            {/* Paginador */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
              <Paginador pages={pages} pageActual={pageActual} setPageActual={setPageActual} mode={mode} />
            </div>

            {/* Info resultados */}
            <div style={{ fontSize: 10, color: '#64748b' }}>
              ({startLimit + 1} – {dataList.length > parseInt(pageActual) * parseInt(limitList) ? parseInt(pageActual) * parseInt(limitList) : dataList.length}) {lang[languaje]['de']} <strong style={{ color: '#334155' }}>{dataList.length}</strong> {lang[languaje]['resultados']}
            </div>

            {/* Botón Aceptar */}
            <Action
              disabled={false}
              origen='Azul'
              titulo={capitalizeFirstLetter(lang[languaje]['aceptar'])}
              action={closHostsListModal}
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default ModalHostList;
